import { memoize } from "lodash";
import { observable, runInAction } from "mobx";
import getCoreStorageStore from "../core/core-storage-store";
import {
  E_LOCAL_STORAGE_KEY,
  E_STORAGE_TYPE
} from "../../constants/storage-constants";
import { soundHelper } from "../../helpers/sound-helper";

class NotificationSoundStore {
  //MH: later create settings store and in it include notifications and maybe allow enabling notifications for some and disabling for some.

  isSoundEnabled = observable.box<boolean>(true);

  setIsSoundEnabledFromStorage = () => {
    runInAction(() => {
      this.isSoundEnabled.set(
        getCoreStorageStore(E_STORAGE_TYPE.LOCAL).get<boolean>(
          E_LOCAL_STORAGE_KEY.NOTIFICATION_SOUND_ENABLED
        )
      );
    });
  };

  toggleSound = () => {
    const newSoundState = !this.isSoundEnabled.get();
    getCoreStorageStore(E_STORAGE_TYPE.LOCAL).set(
      E_LOCAL_STORAGE_KEY.NOTIFICATION_SOUND_ENABLED,
      newSoundState
    );
    runInAction(() => {
      this.isSoundEnabled.set(newSoundState);
    });
  };

  playNotificationSound = () => {
    if (!this.isSoundEnabled.get()) {
      return;
    }
    soundHelper.playNotification();
  };
}
export const getNotificationSoundStore = memoize(
  () => {
    return new NotificationSoundStore();
  },
  () => 1
);
